import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getAccountMarketingMaterialFlyerQrCodeValue } from '../AccountMarketingMaterialFlyerPrintTemplate/helpers';

const CUSTOM_DESIGN_TEMPLATE_INSTRUCTIONS_AREA = {
  left: '56.5%',
  top: '53%',
  width: '35.5%',
  height: '47.5%',
};

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string,
  }),
  customDesign: PropTypes.shape({
    id: PropTypes.string,
    marketing_material_asset: PropTypes.shape({
      id: PropTypes.string,
      asset_image: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const AccountMarketingMaterialCustomDesignTemplate = ({
  albumFolder,
  account,
  customDesign,
}) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const url = getAccountMarketingMaterialFlyerQrCodeValue({
    albumFolder,
    account,
  });

  return (
    <Fragment>
      <div
        className="marketing-material-custom-design-instructions"
        style={{
          ...CUSTOM_DESIGN_TEMPLATE_INSTRUCTIONS_AREA,
        }}
      >
        <p className="marketing-material-custom-design-instructions-title">
          How to receive your photo proofs:
        </p>
        <ol>
          <li>Scan the QR code with your camera.</li>
          <li>Snap a selfie to join the event.</li>
          <li>Let Waldo find your photos and text them to you!.</li>
        </ol>
        <div className="marketing-material-custom-design-qrcode">
          <QRCode renderAs="canvas" value={url} size={width * 0.22 || 500} />
        </div>
      </div>

      <img
        ref={templateRef}
        className="marketing-material-custom-design-background"
        src={customDesign?.marketing_material_asset?.asset_image?.url}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialCustomDesignTemplate.propTypes = propTypes;

export default AccountMarketingMaterialCustomDesignTemplate;
